export { default } from './StatusLabel';



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/StatusLabel/index.js